import { Routes, RouterModule, Route } from "@angular/router";

import { ErrorPageComponent } from "./components/error-page/error-page.component";
import { LoginGuard } from "./guards/login-guard";
import { ContentMenuResolver } from "./components/cms/content/content.resolver.service";
import { NotificationGuard } from "./guards/notification-guard";
import { RoleGuard } from "./guards/role";

const appRouter: Route[] = [
  {
    path: 'social',
    loadChildren: () => import('./components/social/social.routes').then(m => m.socialRoutes),
    canActivate: [NotificationGuard],
    data: { breadcrumb: 'Rede Social' }
  },
  {
    path: 'users',
    loadChildren: () => import('./components/users/users.module').then(m => m.UsersModule),
    canActivate: [NotificationGuard],
    data: { breadcrumb: 'breadcrumb.users.users' }
  },
  {
    path: 'accessprofiles',
    loadChildren: () => import('./components/access-profile/access-profile.routes').then(m => m.AccessProfileRoutes),
    canActivate: [NotificationGuard],
    data: { breadcrumb: 'breadcrumb.accessprofiles.accessprofiles' }
  },
  {
    path: 'cms',
    loadChildren: () => import('./components/cms/cms.module').then(m => m.CmsModule),
    canActivate: [NotificationGuard],
    data: { breadcrumb: 'breadcrumb.cms.cms' }
  },
  {
    path: 'hp',
    loadChildren: () => import('./components/view/view-with-routing.module').then(m => m.ViewWithRoutingModule),
    canActivate: [NotificationGuard],
    data: { breadcrumb: '' }
  },
  {
    path: 'templates',
    loadChildren: () => import('./components/templates/templates.module').then(m => m.TemplateModule),
    canActivate: [NotificationGuard],
    data: { breadcrumb: '' }
  },
  {
    path: 'features',
    loadChildren: () => import('./components/features/features.routes').then(m => m.featuresRoutes),
    canActivate: [NotificationGuard],
    data: { breadcrumb: 'breadcrumb.features.features' }
  },
  {
    path: 'workflow',
    loadChildren: () => import('./components/workflow/workflow.module').then(m => m.WorkflowModule),
    canActivate: [NotificationGuard],
    data: { breadcrumb: 'breadcrumb.workflow.workflow' }
  },
  {
    path: 'login',
    loadChildren: () => import('./components/new-login/new-login.module').then(m => m.NewLoginModule)
  },
  {
    path: 'platform',
    loadChildren: () => import('./components/platform-config/platform-config.module').then(m => m.PlatformConfigModule),
    canActivate: [NotificationGuard],
    data: { breadcrumb: 'Configuração da Plataforma' }
  },
  {
    path: 'media',
    loadChildren: () => import('./components/media/media.module').then(m => m.MediaModule),
    canActivate: [NotificationGuard],
    data: { breadcrumb: 'Gestão de Mídias' }
  },
  {
    path: 'modules',
    loadChildren: () => import('./components/modules-config/modules-config.module').then(m => m.ModulesConfigModule),
    canActivate: [NotificationGuard],
    data: { breadcrumb: 'Módulos' }
  },
  {
    path: 'calendar',
    loadChildren: () => import('./components/calendar/calendar.module').then(m => m.CalendarModule),
    canActivate: [NotificationGuard],
    data: { breadcrumb: 'Calendários' }
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./components/dashboard/dashboard.routes').then(m => m.dashboardRoutes),
    canActivate: [NotificationGuard],
    data: { breadcrumb: 'breadcrumb.dashboard.dashboard' }
  },
  {
    path: 'dashboard-pro',
    loadChildren: () => import('./components/dashboard-pro/dashboard-pro.routes').then(m => m.dashboardProRoutes),
    canActivate: [NotificationGuard],
    data: { breadcrumb: 'Dashboard Pro' }
  },
  {
    path: 'chats',
    loadChildren: () => import('./components/chat/chat.module').then(m => m.ChatModule),
    canActivate: [NotificationGuard],
    data: { breadcrumb: 'breadcrumb.chat.chat' }
  },
  {
    path: 'lms/certificates/validate/:token',
    loadComponent: () =>
      import('./components/lms/learner/lms-certificate-validate/lms-certificate-validate.component').then(
        m => m.LmsCertificateValidateComponent,
      ),
    data: { breadcrumb: 'Validação de certificado' },
  },
  {
    path: 'lms',
    loadChildren: () => import('./components/lms/learner/lms-learner.module').then(m => m.LmsLearnerModule),
    canActivate: [NotificationGuard],
    data: { breadcrumb: 'breadcrumb.lms.lms' }
  },
  {
    path: 'lms-2.0/certificates/validate/:token',
    loadComponent: () =>
      import('./components/lms-2.0/learner/lms-certificate-validate/lms-certificate-validate.component').then(
        m => m.LmsCertificateValidateComponent,
      ),
    data: { breadcrumb: 'Validação de certificado' },
  },
  {
    path: 'lms-2.0',
    loadChildren: () =>
      import('./components/lms-2.0/learner/lms-learner.module').then(m => m.LmsLearnerModule),
    canActivate: [NotificationGuard],
    data: { breadcrumb: 'breadcrumb.lms.lms' }
  },
  {
    path: 'gamistore-view',
    loadChildren: () => import('./components/gamistore-view/gamistore-view.routes').then(m => m.GamistoreViewRouting),
    canActivate: [NotificationGuard],
    data: {breadcrumb: 'breadcrumb.gamistoreview.gamistoreview' }
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
    data: { breadcrumb: 'login' }
  },
  {
    path: 'error/:status',
    component: ErrorPageComponent,
    canActivate: [LoginGuard]
  },
  {
    path: '**',
    component: ErrorPageComponent,
    data: { status: 404 },
    canActivate: [LoginGuard],
    resolve: { menu: ContentMenuResolver }
  }

]

export const routing = RouterModule.forRoot(appRouter, {})
